import React, { useEffect } from 'react';
import { RouteComponentProps, Switch, Route, Redirect } from 'react-router-dom';
import Title from 'components/Title';
import ui from 'stores/ui';
import Unsubscribe from './modules/Unsubscribe';
import './style.scss';

const Email: React.FC<RouteComponentProps> = props => {
    const parentPath = props.match.path;

    useEffect(() => {
        ui.setClearMode(true);

        return () => {
            ui.setClearMode(false);
        };
    }, []);

    return (
        <div className="email-root">
            <Title title="Email Unsubscribe" />
            <header className="email-header"></header>
            <div className="email-body">
                <Switch>
                    <Route exact path={`${parentPath}/unsubscribe`} component={Unsubscribe} />
                    <Redirect to={`${parentPath}/unsubscribe`} />
                </Switch>
            </div>
        </div>
    );
};

export default Email;
